import { create } from 'zustand';
import { useShallow } from 'zustand/shallow';

/* -------------------------------------------------------------------------- */
export enum OnboardingStepsEnum {
	UPDATE_AVATAR_AND_USERNAME = 'UPDATE_AVATAR_AND_USERNAME',
	COMPLETE_LEVEL_1_KYC = 'COMPLETE_LEVEL_1_KYC',
	VERIFY_EMAIL = 'VERIFY_EMAIL',
	ONBOARDING_SKIPPED = 'ONBOARDING_SKIPPED',
	ONBOARDING_COMPLETED = 'ONBOARDING_COMPLETED',
}
/* -------------------------------------------------------------------------- */

interface OnboardingStore {
	onboardingStep: OnboardingStepsEnum;
	showDepositPopup: boolean;

	actions: {
		setOnboardingStep: (step: OnboardingStepsEnum) => void;
		setShowDepositPopup: (show: boolean) => void;

		resetUserStore: () => void;
	};
}

const initialState = {
	onboardingStep: OnboardingStepsEnum.UPDATE_AVATAR_AND_USERNAME,
	showDepositPopup: false,
};

const onboardingStore = create<OnboardingStore>((set) => ({
	...initialState,

	/* -------------------------------------------------------------------------- */

	actions: {
		setOnboardingStep: (step: OnboardingStepsEnum) => {
			set(() => ({
				onboardingStep: step,
			}));
		},
		setShowDepositPopup: (show: boolean) => {
			set(() => ({
				showDepositPopup: show,
			}));
		},
		resetUserStore: () => {
			set(() => ({
				...initialState,
			}));
		},
	},
}));

export const useOnboardingStep = () =>
	onboardingStore(useShallow((state) => state.onboardingStep));

export const useShowDepositPopup = () =>
	onboardingStore(useShallow((state) => state.showDepositPopup));

export const useOnboardingStoreActions = () =>
	onboardingStore((state) => state.actions);
